import { Img, Text, Heading } from "../../components";
import MachinePerformanceOverview from "../../components/MachinePerformanceOverview";
import React, { Suspense } from "react";

const machinePerformanceList = [
  {
    trophyImage: "images/img_trophy.svg",
    performanceHeading: "Machine performance",
    sensorDataText: "Plug in existing and new sensor data.",
    monitoringText: "Monitor and predict machine performance with condition-based monitoring.",
    maintenanceText: "Schedule preventive maintenance and prevent costly failures.",
  },
  {
    trophyImage: "images/img_user.svg",
    performanceHeading: "Process control",
    sensorDataText: "Seamlessly integrate existing data sources with our platform.",
    monitoringText: "Setup your shop floor process and remote factory through our interface.",
    maintenanceText: "Accurately identify bottlenecks in processes, provide visibility to partners and customers.",
  },
  {
    trophyImage: "images/img_trophy.svg",
    performanceHeading: "Safety & Compliance",
    sensorDataText: "Monitor energy and water consumption and assess carbon footprints for your factory.",
    monitoringText: "Human resource monitoring and safety through AI Vision helps avoid risks, thereby improving worker safety and plant reliability.",
    maintenanceText: "Schedule preventive maintenance and prevent costly failures.",
  },
];

export default function FactoryOptimizationSection() {
  return (
    <>
      {/* Factory optimization section */}
      <div>
        <div className="bg-gradient1 px-6 pb-6 md:pb-5 md:pt-[60px] sm:pb-40">
          <div>
            <div className="mb-3.5 flex flex-col items-center gap-[92px] md:gap-[50px] sm:gap-[46px]">
              <div className="w-full px-10 md:px-5"> {/* w-full to ensure full width container */}
                <div className="mr-2.5 flex flex-col items-center gap-4 md:mr-0">
                  <Heading
                    as="h2"
                    className="text-[46px] font-bold text-white md:text-[42px] sm:p-2.5 sm:text-center sm:text-[24px]"
                  >
                    Key steps to your factory of the future
                  </Heading>
                  <Text
                    size="text11xl"
                    as="p"
                    className="self-stretch text-center text-[26px] font-normal leading-10 text-white md:text-[24px] sm:p-2.5 sm:text-[18px] sm:leading-6"
                  >
                    Discover how our products can optimize factory performance and unlock smart manufacturing with Industry 4.0 solutions.
                  </Text>
                </div>
              </div>
              <Img
                src="images/img_frame_427319695.png"
                alt="Image"
                className="h-[96px] w-full object-cover md:h-auto"
              />
              <div className="w-full px-5 pb-10 md:px-5">
                {/* Updated flex container */}
                <div className="flex flex-wrap justify-between gap-8">
                  <Suspense fallback={<div>Loading feed...</div>}>
                    {machinePerformanceList.map((data, index) => (
                      <MachinePerformanceOverview
                        {...data}
                        key={`machineList_${index}`}
                        className="w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/4"  // Set appropriate width for each item
                      />
                    ))}
                  </Suspense>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
